export default "__VITE_ASSET__FsB327n6__"